import React from "react";
import PropTypes from "prop-types";
import tw from "twin.macro";

const Container = tw.div``;
const Label = tw.label`text-xs tracking-wide block text-white w-full`;
const CustomInput = tw.input`border border-blue-900 w-full rounded focus:shadow p-2 text-sm`;

const Input = ({ label, id, ...rest }) => (
  <Container>
    <Label htmlFor={id}>{label}</Label>
    <CustomInput id={id} {...rest} />
  </Container>
);

Input.propTypes = {
  label: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired
};

export default Input;
